import { useEffect, useRef, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import './App.css';
import './styles/branding.css';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Footer, InfoDialog } from './components/Footer';
import { UIContext } from './context/UIContext';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { Fantasti3D } from './pages/Fantasti3D';

export default function App() {
  const [info, setInfo] = useState(null);
  const lenis = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;
    const scroll = new Lenis({ autoRaf: true, duration: 1.15, smoothWheel: true, anchors: true });
    lenis.current = scroll;
    return () => { scroll.destroy(); lenis.current = null; };
  }, []);

  useEffect(() => {
    if (window.location.hash) return;
    if (lenis.current) lenis.current.scrollTo(0, { immediate: true }); else window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => { if (info) lenis.current?.stop(); else lenis.current?.start(); }, [info]);

  return <MotionConfig reducedMotion="user"><UIContext.Provider value={{ setInfo, lenis }}>
    <a className="skip-link" href="#content" data-testid="skip-to-content">Vai al contenuto</a>
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/fantasti3d" element={<Fantasti3D />} />
    </Routes>
    <Footer onInfo={setInfo} />
    <InfoDialog type={info} onClose={() => setInfo(null)} />
    <Toaster theme="dark" position="bottom-right" richColors />
  </UIContext.Provider></MotionConfig>;
}
